module.exports = __webpack_public_path__ + "images/eq_play.3f408bad.gif";